import { Box, type SxProps, type Theme } from '@mui/material';

/**
 * ActionWrapper Component
 * 
 * Shared wrapper for action areas in card components.
 * Provides a gradient overlay that fades from transparent to background color,
 * with the action content centered at the bottom.
 * 
 * Used by both FeatureCard and MiniTile components.
 */
interface ActionWrapperProps {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

export const ActionWrapper: React.FC<ActionWrapperProps> = ({ children, sx }) => (
  <Box
    sx={{
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      pb: 3,
      pt: 5,
      background: (theme) => `linear-gradient(180deg,
        transparent 0%,
        ${theme.palette.backgroundColors?.secondary} 50%)`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      // eslint-disable-next-line @typescript-eslint/no-misused-spread
      ...sx,
    }}
  >
    {children}
  </Box>
);